import type { FieldErrors, UseFormRegister } from 'react-hook-form'
import clsx from 'clsx'
import { sanitizeFieldName } from '@/utils/sanitizedLabel'

type Props = {
	id: string
	label: string
	required: boolean
	formStyle: string
	colSpan?: string
	register: UseFormRegister<any>
	errors: FieldErrors
	className?: string
	selectOptions?: string[]
}

export default function SingleChoice({
	id,
	label,
	required,
	formStyle,
	colSpan = '1',
	register,
	errors,
	className,
	selectOptions = [],
}: Props) {
	const fieldName = sanitizeFieldName(label)

	return (
		<div
			className={clsx(
				'form-component',
				{
					'2': 'colSpan2',
				}[colSpan],
				className
			)}
		>
			<label className="my-2">{`${label} ${required ? '*' : ''}`}</label>

			<div className="grid grid-cols-1 gap-3">
				{selectOptions.map((option, index) => (
					<label
						key={`${id}-${index}`}
						className={clsx(
							'flex items-center gap-3 cursor-pointer px-5 h-16 rounded-lg transition-colors bg-white-frosted',
							'hover:bg-white-frosted-shade has-[:checked]:bg-white-frosted-shade',
							formStyle === 'line' ? 'border-b' : 'rounded-lg'
						)}
					>
						<input
							type="radio"
							id={`${id}-${index}`}
							value={option}
							className="w-5 h-5 cursor-pointer rounded-full"
							{...register(fieldName, {
								required: required && `${label} is required`,
							})}
						/>
						<span className="flex-1">{option}</span>
					</label>
				))}
			</div>

			{errors[fieldName] && (
				<span className="mt-1 text-red-500">{errors[fieldName]?.message?.toString()}</span>
			)}
		</div>
	)
}
